import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'fa',
  Pagination: {
    items_per_page: '/ صفحه',
    jump_to: 'برو به',
    jump_to_confirm: 'تایید',
    page: '',
    prev_page: 'صفحه قبلی',
    next_page: 'صفحه بعدی',
    prev_5: '۵ صفحه قبلی',
    next_5: '۵ صفحه بعدی',
    prev_3: '۳ صفحه قبلی',
    next_3: '۳ صفحه بعدی',
  },
  DatePicker: {
    lang: {
      placeholder: 'انتخاب تاریخ',
      yearPlaceholder: 'انتخاب سال',
      quarterPlaceholder: 'انتخاب فصل',
      monthPlaceholder: 'انتخاب ماه',
      weekPlaceholder: 'انتخاب هفته',
      rangePlaceholder: [
        'تاریخ شروع',
        'تاریخ پایان',
      ],
      rangeYearPlaceholder: [
        'سال شروع',
        'سال پایان',
      ],
      rangeMonthPlaceholder: [
        'ماه شروع',
        'ماه پایان',
      ],
      rangeWeekPlaceholder: [
        'هفته شروع',
        'هفته پایان',
      ],
      locale: 'fa_IR',
      today: 'امروز',
      now: 'اکنون',
      backToToday: 'بازگشت به روز',
      ok: 'باشه',
      clear: 'پاک کردن',
      month: 'ماه',
      year: 'سال',
      timeSelect: 'انتخاب زمان',
      dateSelect: 'انتخاب تاریخ',
      monthSelect: 'یک ماه را انتخاب کنید',
      yearSelect: 'یک سال را انتخاب کنید',
      decadeSelect: 'یک دهه را انتخاب کنید',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'ماه قبل (PageUp)',
      nextMonth: 'ماه بعد (PageDown)',
      previousYear: 'سال قبل (Control + left)',
      nextYear: 'سال بعد (Control + right)',
      previousDecade: 'دهه قبل',
      nextDecade: 'دهه بعد',
      previousCentury: 'قرن قبل',
      nextCentury: 'قرن بعد',
    },
    timePickerLocale: {
      placeholder: 'انتخاب زمان',
      rangePlaceholder: [
        'زمان شروع',
        'زمان پایان',
      ],
    },
  },
  TimePicker: {
    placeholder: 'انتخاب زمان',
    rangePlaceholder: [
      'زمان شروع',
      'زمان پایان',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'انتخاب تاریخ',
      yearPlaceholder: 'انتخاب سال',
      quarterPlaceholder: 'انتخاب فصل',
      monthPlaceholder: 'انتخاب ماه',
      weekPlaceholder: 'انتخاب هفته',
      rangePlaceholder: [
        'تاریخ شروع',
        'تاریخ پایان',
      ],
      rangeYearPlaceholder: [
        'سال شروع',
        'سال پایان',
      ],
      rangeMonthPlaceholder: [
        'ماه شروع',
        'ماه پایان',
      ],
      rangeWeekPlaceholder: [
        'هفته شروع',
        'هفته پایان',
      ],
      locale: 'fa_IR',
      today: 'امروز',
      now: 'اکنون',
      backToToday: 'بازگشت به روز',
      ok: 'باشه',
      clear: 'پاک کردن',
      month: 'ماه',
      year: 'سال',
      timeSelect: 'انتخاب زمان',
      dateSelect: 'انتخاب تاریخ',
      monthSelect: 'یک ماه را انتخاب کنید',
      yearSelect: 'یک سال را انتخاب کنید',
      decadeSelect: 'یک دهه را انتخاب کنید',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'ماه قبل (PageUp)',
      nextMonth: 'ماه بعد (PageDown)',
      previousYear: 'سال قبل (Control + left)',
      nextYear: 'سال بعد (Control + right)',
      previousDecade: 'دهه قبل',
      nextDecade: 'دهه بعد',
      previousCentury: 'قرن قبل',
      nextCentury: 'قرن بعد',
    },
    timePickerLocale: {
      placeholder: 'انتخاب زمان',
      rangePlaceholder: [
        'زمان شروع',
        'زمان پایان',
      ],
    },
  },
  global: {
    placeholder: 'لطفاً انتخاب کنید',
  },
  Table: {
    filterTitle: 'منوی فیلتر',
    filterConfirm: 'تایید',
    filterReset: 'پاک کردن',
    filterEmptyText: 'بدون فیلتر',
    emptyText: 'بدون داده',
    selectAll: 'انتخاب صفحه‌ی کنونی',
    selectInvert: 'معکوس کردن انتخاب‌ها در صفحه ی کنونی',
    selectNone: 'انتخاب هیچکدام',
    selectionAll: 'انتخاب همه داده‌ها',
    sortTitle: 'مرتب سازی',
    expand: 'باز شدن ردیف',
    collapse: 'بستن ردیف',
    triggerDesc: 'ترتیب نزولی',
    triggerAsc: 'ترتیب صعودی',
    cancelSort: 'لغوِ ترتیبِ داده شده',
  },
  Modal: {
    okText: 'تایید',
    cancelText: 'لغو',
    justOkText: 'تایید',
  },
  Popconfirm: {
    okText: 'تایید',
    cancelText: 'لغو',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'جستجو',
    itemUnit: 'عدد',
    itemsUnit: 'عدد',
    remove: 'حذف',
    selectCurrent: 'انتخاب صفحه فعلی',
    removeCurrent: 'پاک کردن انتخاب‌های صفحه فعلی',
    selectAll: 'انتخاب همه',
    removeAll: 'پاک کردن همه انتخاب‌ها',
    selectInvert: 'معکوس کردن انتخاب‌ها در صفحه ی کنونی',
  },
  Upload: {
    uploading: 'در حال آپلود...',
    removeFile: 'حذف فایل',
    uploadError: 'خطا در آپلود',
    previewFile: 'مشاهده‌ی فایل',
    downloadFile: 'دریافت فایل',
  },
  Empty: {
    description: 'داده‌ای موجود نیست',
  },
  Icon: {
    icon: 'آیکن',
  },
  Text: {
    edit: 'ویرایش',
    copy: 'کپی',
    copied: 'کپی شد',
    expand: 'توسعه',
  },
  PageHeader: {
    back: 'برگشت',
  },
  Form: {
    optional: '(اختیاری)',
    defaultValidateMessages: {
      default: 'خطا در ${label}',
      required: 'فیلد ${label} اجباریست',
      enum: '${label} باید یکی از [${enum}] باشد',
      whitespace: '${label} نمیتواند خالی باشد',
      date: {
        format: 'ساختار تاریخ در ${label} نامعتبر است',
        parse: '${label} قابل تبدیل به تاریخ نیست',
        invalid: '${label} تاریخی نا معتبر است',
      },
      types: {
        string: '${label} از نوع ${type} معتبر نیست',
        method: '${label} از نوع ${type} معتبر نیست',
        array: '${label} از نوع ${type} معتبر نیست',
        object: '${label} از نوع ${type} معتبر نیست',
        number: '${label} از نوع ${type} معتبر نیست',
        date: '${label} از نوع ${type} معتبر نیست',
        boolean: '${label} از نوع ${type} معتبر نیست',
        integer: '${label} از نوع ${type} معتبر نیست',
        float: '${label} از نوع ${type} معتبر نیست',
        regexp: '${label} از نوع ${type} معتبر نیست',
        email: '${label} از نوع ${type} معتبر نیست',
        url: '${label} از نوع ${type} معتبر نیست',
        hex: '${label} از نوع ${type} معتبر نیست',
      },
      string: {
        len: '${label} باید ${len} کاراکتر باشد',
        min: '${label} باید حداقل ${min} کاراکتر باشد',
        max: '${label} باید حداکثر ${max} کاراکتر باشد',
        range: '${label} باید بین ${min}-${max} کاراکتر باشد',
      },
      number: {
        len: '${label} باید برابر ${len}',
        min: '${label} حداقل میتواند ${min} باشد',
        max: '${label} حداکثر میتواند ${max} باشد',
        range: '${label} باید بین ${min}-${max} باشد',
      },
      array: {
        len: 'تعداد ${label} باید ${len} باشد.',
        min: 'تعداد ${label} حداقل باید ${min} باشد',
        max: 'تعداد ${label} حداکثر باید ${max} باشد',
        range: 'مقدار ${label} باید بین ${min}-${max} باشد',
      },
      pattern: {
        mismatch: 'الگوی ${label} با ${pattern} برابری نمی‌کند',
      },
    },
  },
  Image: {
    preview: 'نمایش',
  },
};

export default localeValues;
